import React, { PropsWithChildren } from 'react';
import { ThemeImage } from '../../controls/ThemeImage/ThemeImage';
import { isElectron } from '../../helpers/EnvironmentFlags/EnvironmentFlags';
import css from './Content.module.scss';
import { usePageState } from '../../context/Page/page';
import { LocalizationButtons } from '../../controls/LocalizationButtons/LocalizationButtons';
import { useLocalization } from '../../context/Localization/localization';
import { useKioskState } from '../../context/Kiosk/kiosk';

interface IProps {
    suppressLocalizationButtons?: boolean;
}

export const Content: React.FC<PropsWithChildren<IProps>> = React.memo((props) => {
    const pageState = usePageState();
    const Localization = useLocalization();
    const {
        dealer: { name: dealerName },
    } = useKioskState();

    return (
        <main id={'page-content'} className={css.content}>
            {pageState.showKioskBanner ? <ThemeImage themeImageType={'internalBanner'} /> : null}
            {isElectron() || <h1 className={css.displayNone}>{Localization.formatString(Localization.MobileCheckInHeader, dealerName) as string}</h1>}
            {isElectron() || (!props.suppressLocalizationButtons && <LocalizationButtons displayAsLinks />)}
            <div className={css.innerContent}>{props.children}</div>
            {pageState.showKioskBackground ? (
                <div className={css.contentBackground}>
                    <ThemeImage themeImageType={'internalBackground'} />
                </div>
            ) : null}
        </main>
    );
});
